import { useEffect, useRef, useState } from "react";

export default function useFormDraft(key, initialValue) {
  const [state, setState] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved ? JSON.parse(saved) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const t = useRef(null);
  useEffect(() => {
    if (t.current) clearTimeout(t.current);
    t.current = setTimeout(() => {
      try { localStorage.setItem(key, JSON.stringify(state)); } catch {}
    }, 250);
    return () => { if (t.current) clearTimeout(t.current); };
  }, [key, state]);

  const clearDraft = () => {
    try { localStorage.removeItem(key); } catch {}
  };

  return [state, setState, clearDraft];
}
